import { render, staticRenderFns } from "./nav-view-link.vue?vue&type=template&id=2f3acdc6&"
import script from "./nav-view-link.vue?vue&type=script&lang=ts&"
export * from "./nav-view-link.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports